import { useMutation, useQueryClient } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { CalendarAndTasksData, HttpResponse, Task } from "@/types";

export function useDeleteRemoveDashboardTask() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number) => {
      const path = `tasks/${id.toString()}`;
      const res = await guacHttpClient.delete<Task, HttpResponse<Task>>(path);
      return res.data;
    },
    onSuccess: (_task, id) => {
      queryClient.setQueriesData<CalendarAndTasksData>(
        { queryKey: ["calendar-and-tasks"] },
        (cachedData) => {
          if (!cachedData) return cachedData;
          return {
            ...cachedData,
            tasks: cachedData.tasks.filter((task) => task.id !== id),
          };
        },
      );
    },
  });
}
